<template>
  <!-- 粉丝 -->
  <div class="cont-fensi cont-haoyou page-question">
    <ul class="user-much-num clearfix">
      <router-link tag="li" to="/home/wenda?userId=1&selectId=0"><span>我的提问</span></router-link>
      <router-link tag="li" to="/home/wenda?userId=1&selectId=1" class="active"><span>我的回答</span></router-link>
      <router-link tag="li" to="/home/wenda?userId=1&selectId=2"><span>我的关注</span></router-link>
    </ul>
    <div class="detail-title"><span>悬赏￥100</span> iClone7常见问答:如何改变默认是切线类型</div>
    <div class="pro-work-item clearfix">
      <div class="user-avatar">
        <router-link to="/" class="avatar-f">
          <img :src="require('@/assets/images/user_avatar.jpg')" alt="">
        </router-link>
      </div>
      <div class="item-infoes">
        <div class="user-name-title clearfix">
          <router-link to="/" class="name">张三四</router-link>
          <el-button class="set-best-btn" type="primary">最佳回答</el-button>
          <span class="show-date">2天前</span>
        </div>
        <overflow-words words="普通优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付普通优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付" />
        <icons-talk class="icons-talk" />
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import overflowWords from '../../question/pub/overflow'
import iconsTalk from '../../question/pub/iconsTalk'

export default {
  components: {
    iconsTalk,
    overflowWords
  },
  data () {
    return {
      
    }
  },
  methods: {
    
  }
}
</script>

<style scoped lang="less">
@import "../../../assets/less/stylePublic.less";
.cont-haoyou{
  &.cont-fensi{
    padding-top: 0px;
  }
  .user-much-num{
    li{
      float: left;
      margin-right: 20px;
      font-size: 14px;
      cursor: pointer;
      &.active{
        position: relative;
        &:after{
          position: absolute;
          bottom: 0;
          left: 0;
          content: '';
          display: block;
          width: 100%;
          height: 2px;
          background: #515151;
        }
      }
    }
  }
  .detail-title{
    padding: 20px 20px 0;
    color: #333;
    font-size: 18px;
    font-weight: bold;
    span{
      color: #ff0000;
    }
  }
  .pro-work-item{
    padding-top: 10px;
    .icons-talk{
      margin-top: 5px;
    }
    .set-best-btn{
      margin-top: 10px;
      margin-left: 5px;
      width: 90px;
      height: 30px;
    }
    .show-date{
      margin-top: 10px;
      margin-left: 10px;
      line-height: 30px;
      font-size: 12px;
    }
  }
}
@media screen and (max-width: 750px) {
  .cont-haoyou{
    margin-top: 30px;
    .user-much-num{
      top: -30px !important;
      line-height: 30px !important;
    }
  }
}
</style>
